import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Topbar } from '../components/chrome/Topbar.js';
import { Btn } from '../components/chrome/Buttons.js';

const ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';

function generateCode(): string {
  let out = '';
  const buf = new Uint8Array(6);
  crypto.getRandomValues(buf);
  for (let i = 0; i < 6; i++) out += ALPHABET[buf[i]! % ALPHABET.length];
  return out;
}

export function Lobby() {
  const nav = useNavigate();
  const [hostCode] = useState(() => generateCode());
  const [joinCode, setJoinCode] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1400);
    return () => clearTimeout(t);
  }, [copied]);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(hostCode);
      setCopied(true);
    } catch {
      /* clipboard API may be unavailable; ignore */
    }
  };

  const onHost = () => {
    nav(`/battle/friend?code=${hostCode}`);
  };

  const onJoin = () => {
    const code = joinCode.toUpperCase().trim();
    if (code.length !== 6) return;
    nav(`/battle/friend?code=${code}`);
  };

  return (
    <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Topbar title="Friend Match" />
      <div className="lobby">
        <div className="header">
          <h1>SHARE<br />YOUR CODE</h1>
          <p>Send to a friend to start the match</p>
        </div>

        <div className="codeBox">
          <label>your code</label>
          <div className="code">
            {hostCode}
            <button type="button" className="copy-btn" onClick={onCopy}>
              {copied ? 'COPIED' : 'COPY'}
            </button>
          </div>
        </div>

        <Btn variant="primary" block onClick={onHost}>HOST MATCH</Btn>

        <div className="or">or join a friend</div>

        <div className="joinBox">
          <input
            placeholder="ENTER CODE"
            maxLength={6}
            value={joinCode}
            onChange={(e) => setJoinCode(e.target.value.toUpperCase())}
            inputMode="text"
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
          />
          <Btn variant="blue" onClick={onJoin}>JOIN</Btn>
        </div>
      </div>
    </div>
  );
}
